module.exports = function () {
  return "\n    <div id=\"log-wrapper\">\n      <div id=\"mobile-log-tab\" class=\"mobile-log-tab\"><i class=\"fas fa-angle-left\"></i></div>\n      <div id=\"log\" class=\"log\"></div>\n    </div>\n  ";
};